<template>
  <div>
    <callout
      :border-color="getColor(value.statusId)"
      class="ticket"
      controlled
      :opened="value.isOpen"
      @click:open="openCallout(mode.Additional_Info)"
    >
      <div class="row mt-2 mx-0">
        <div class="col-12 col-md-3">
          <balloon
            :background-color="`bg-${getColor(value.statusId)}`"
            class="
              mt-2
              font-weight-normal font-16
              d-flex
              justify-content-center
              align-items-center
              w-90
              ml-3
              mb-3
              font-weight-bold
            "
            color="font-weight-bold"
            :text="value.statusName"
          />
        </div>
        <div class="col-12 col-md mb-3 mb-md-0">
          <div class="color-secondary-6 font-14 font-weight-normal">
            Número de Caso:
          </div>
          <span class="color-black font-16">
            {{ value.caseNumber }}
          </span>
        </div>
        <div class="col-12 col-md mb-3 mb-md-0">
          <div class="color-secondary-6 font-14 font-weight-normal">
            Aplicación:
          </div>
          <span class="color-black font-16">
            {{ value.application }}
          </span>
        </div>
        <div class="col-12 col-md mb-3 mb-md-0">
          <div class="color-secondary-6 font-14 font-weight-normal">Fecha:</div>
          <span class="color-black font-16">
            {{ value.createdDate | date }}
          </span>
        </div>
        <div class="col-12 col-md align-self-center text-center">
          <drop-down :items="actionItems" />
        </div>
      </div>
      <template #edition>
        <div class="mt-1 px-2 py-2">
          <div class="bg-white rounded">
            <validation-observer
              v-if="value.mode === mode.Additional_Info"
              ref="additionalInfoVO"
              class="p-3"
              tag="div"
            >
              <div class="bold mb-2">
                <em class="fa fa-file-search color-orange" />
                Información Adicional de la Solicitud
              </div>
              <validation-provider
                ref="additionalInfoCommentVP"
                v-slot="{ errors }"
                rules="required"
              >
                <custom-text-area
                  id="comment"
                  v-model="additionalInfo.comment"
                  :count-classes="['d-block text-right']"
                  custom-error-msg="El comentario es requerido."
                  :error="errors[0]"
                  label="Comentario:"
                  :maxlength="3000"
                  name="managementComment"
                  show-char-count
                />
              </validation-provider>
              <div class="row mt-2">
                <div class="col-6">
                  <div class="font-weight-normal font-14 color-secondary-6">
                    Documento:
                  </div>
                  <custom-file-input
                    ref="fileUpload"
                    v-model="additionalInfo.document.data"
                    :accept="allowedFiles"
                    :attachment-id="additionalInfo.document.id"
                    display-style="normal"
                    label-position="left"
                    :max-size="10"
                    :name="additionalInfo.document.name"
                    :on-download="onDownload"
                  />
                  <small class="data-label allowed-files-message">
                    El sistema le permitirá anejar la evidencia con los
                    siguientes formatos: .jpg, .png, .docx, .doc, .xlsx, .xls,
                    .pdf, .ppt .pptx.
                  </small>
                </div>
                <div class="col-6 text-right my-auto">
                  <action-button
                    i="fas fa-times-circle"
                    text="Cancelar"
                    variant="outline-danger mr-3"
                    @click="onCancelClicked"
                  />
                  <action-button
                    i="fas fa-save"
                    text="Guardar"
                    variant="success"
                    @click="onSaveClicked"
                  />
                </div>
              </div>
            </validation-observer>
            <div v-if="value.mode === mode.Documents" class="p-3">
              <div class="bold mb-2">
                <em class="fa fa-file color-orange" />
                Documentos de Solicitud
              </div>
              <div v-if="caseDocuments.length" class="pl-3 my-2">
                <div v-for="(data, index) in caseDocuments" :key="index">
                  <custom-callout
                    class-main=" mt-3 border-0 ml-sm-5"
                    :has-border="false"
                    :has-gradient="false"
                    :has-toggle="false"
                  >
                    <div class="row mr-md-0">
                      <div class="col col-sm-3">
                        <div class="color-gray-6 font-14">
                          Tipo de Documento:
                        </div>
                        <div class="color-black font-16">
                          {{ data.attachmentCategoryName | empty }}
                        </div>
                      </div>
                      <div class="col col-sm">
                        <div class="color-gray-6 font-14">
                          Nombre del Archivo:
                        </div>
                        <div class="color-black font-16">
                          {{ data.name | empty }}
                        </div>
                      </div>
                      <div class="col col-sm text-sm-right mt-3 mt-sm-1">
                        <action-button
                          i="fas fa-file-download mr-n1 pr-1"
                          variant="success"
                          @click="$emit('on-download-document', data)"
                        />
                      </div>
                    </div>
                  </custom-callout>
                </div>
              </div>
              <custom-result-not-found
                v-if="caseDocuments === null"
                text="La solicitud no cuenta con documentos en sistema."
              />
            </div>
            <comments-history
              v-else-if="value.mode === mode.Comment_History"
              :history="commentsHistory"
            />
          </div>
        </div>
      </template>
    </callout>
    <div
      v-if="value.statusId == caseStatus.PendienteInformacion && value.comment"
      class="comment-container"
    >
      <em class="fal fa-exclamation-circle" />
      <span class="font-weight-bold mx-1">
        Comentario para Información Adicional:
      </span>
      <span class="color-gray-6">
        {{ value.comment }}
      </span>
    </div>
  </div>
</template>

<script>
import DropDown from 'dropdown';
import Callout from 'custom-callout';
import Balloon from 'custom-balloon';
import caseStatus from '@/utils/constants/ticketCaseStatus.js';
import ActionButton from 'ActionButton';
import CustomFileInput from 'CustomFileInput';
import CustomTextArea from 'CustomTextArea';
import CommentsHistory from './CommentsHistory.vue';
import CustomResultNotFound from 'custom-result-not-found';

const CALLOUT_MODE = Object.freeze({
  Additional_Info: 1,
  Comment_History: 2,
  Documents: 3,
});

export default {
  name: 'CaseRow',
  components: {
    Callout,
    Balloon,
    DropDown,
    ActionButton,
    CustomFileInput,
    CustomTextArea,
    CommentsHistory,
    CustomResultNotFound,
  },
  props: {
    value: {
      type: Object,
      require: true,
      default: () => {},
    },
    getCommentHistory: {
      type: Function,
      default: () => Promise.resolve({}),
    },
    getCaseDocuments: {
      type: Function,
      default: () => Promise.resolve({}),
    },
    downloadDocument: {
      type: Function,
      default: () => Promise.resolve({}),
    },
  },
  data: () => ({
    caseStatus,
    mode: CALLOUT_MODE,
    commentsHistory: [],
    caseDocuments: null,
    additionalInfo: {
      document: {},
      comment: null,
    },
    allowedFiles: '.jpg,.png,.docx,.doc,.xlsx,.xls,.pdf,.ppt,.pptx',
    customFileExtensionErrorMsg: 'El formato no es válido.',
  }),
  computed: {
    actionItems() {
      return [
        {
          label: 'Entrar',
          icon: 'fas fa-file-import color-green',
          border: 'bottom',
          click: () => this.openCase(),
        },
        {
          label: 'Historial de Comentarios',
          icon: 'fas fa-history color-green',
          click: () => this.openCallout(CALLOUT_MODE.Comment_History),
        },
        {
          label: 'Añadir Información Adicional',
          icon: 'fas fa-file-plus color-green',
          visible: this.value.statusId == caseStatus.PendienteInformacion,
          click: () => this.openCallout(CALLOUT_MODE.Additional_Info),
        },
        {
          label: 'Ver Documentos',
          icon: 'fas fa-file color-green',
          visible: true,
          click: () => this.openCallout(CALLOUT_MODE.Documents),
        },
        {
          label: 'Eliminar',
          icon: 'fas fa-trash-alt color-red',
          visible: this.value.statusId == caseStatus.Nuevo,
          click: () => this.deleteCase(),
        },
      ];
    },
    getColor() {
      return (statusId) => {
        switch (statusId) {
          case caseStatus.Nuevo:
            return 'yellow';
          case caseStatus.Cancelado:
          case caseStatus.DevueltoAsistenciaMIPE:
            return 'brown';
          case caseStatus.PendienteInformacion:
            return 'violet';
          case caseStatus.Resuelto:
            return 'green-light';
          case caseStatus.EnProceso:
            return 'yellow-star';
          default:
            return 'yellow-star';
        }
      };
    },
  },
  methods: {
    async getHistory() {
      const { data } = await this.getCommentHistory(this.value.caseNumber);
      this.commentsHistory = [...data];
    },
    async getDocuments() {
      const { data } = await this.getCaseDocuments(this.value.caseNumber);
      if (data !== null) this.caseDocuments = [...data];
    },
    deleteCase() {
      this.$emit('on-delete', this.value);
    },
    openCase() {
      this.$emit('on-open', this.value);
    },
    async openCallout(mode) {
      this.resetInfo();
      if (mode == CALLOUT_MODE.Comment_History) await this.getHistory();
      if (mode == CALLOUT_MODE.Documents) await this.getDocuments();
      this.$emit('on-add-comment', mode);
    },
    onCancelClicked() {
      this.resetInfo();
      this.$emit('on-cancel', this.value);
    },
    async onSaveClicked() {
      const isValid = await this.$refs.additionalInfoVO.validate();

      if (isValid) {
        const dto = {
          ...this.additionalInfo,
          itemId: this.value.id,
        };

        this.$emit('on-save-additional-info', dto);
      }
    },
    async onDownload(docId) {
      if (docId) {
        await this.downloadDocument(docId);
      } else {
        const { document } = this.additionalInfo;
        if (document) {
          const fr = new FileReader();
          fr.readAsDataURL(document.content);
          const blob = new Blob([document.content], {
            type: document.contentType,
          });

          const objectURL = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = objectURL;
          link.download = document.filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      }
    },
    resetInfo() {
      this.additionalInfo = {
        document: {},
        comment: null,
      };
      this.caseDocuments = null;
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "@/src/shared/scss/config/_colors.scss";

// ::v-deep .ticket {
//   .border-left--color-purple {
//     border-left-color: map-get($colors, "purple") !important;
//   }
//   .border-top--color-purple {
//     border-top-color: map-get($colors, "purple") !important;
//   }
// }
// .bg-purple {
//   background: map-get($colors, "purple") !important;
// }
// .comment-container {
//   background: map-get($colors, "yellow-light");
//   border-radius: 0.25rem;
//   font-size: 0.875rem;
//   padding: 0.4rem 1rem;
//   margin-top: 0.25rem;
//   em {
//     color: #fcb43c;
//   }
// }

// .allowed-files-message {
//   font-size: 0.75rem !important;
// }
</style>
